import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { ListResponse } from '../models/list-response.model';
import { ReportDecisionRequest, ReportItem } from '../models/report.models';

@Injectable({ providedIn: 'root' })
export class ReportsService {
  private readonly http = inject(HttpClient);

  getReports(status: string | null = 'OPEN', page = 0, size = 20): Observable<ListResponse<ReportItem>> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (status) {
      params = params.set('status', status);
    }

    return this.http.get<ListResponse<ReportItem>>(`${API_BASE_URL}/v1/admin/reports`, { params });
  }

  decide(reportId: number, payload: ReportDecisionRequest): Observable<ReportItem> {
    return this.http.put<ReportItem>(`${API_BASE_URL}/v1/admin/reports/${reportId}/decision`, payload);
  }
}
